import OadpAttributeText from './oadp-attribute-text';
export default OadpAttributeText;
